export const ERROR_TITLE_GENERIC = "Whoopsie";
export const ERROR_BODY_GENERIC = "Well that is awkward, something is wrong";
export const ERROR_STATUS = "status";
